function configuration() {
  'ngInject';
  return configurationURL;
}

export { configuration };
